<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-12">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <div class="row center-xy">
            <div class="col-md-10">&nbsp;</div>
            <div class="text-right mb-3 col-md-2">
                <b-button class="finish-button" variant="success" @click="concluir">
                    Concluir
                    <i class="fas fa-flag-checkered"></i>
                </b-button>
            </div>
        </div>

        <div class="mx-auto">
            <b-row>
                <b-col sm="12" md="12">
                    <b-list-group>
                        <b-list-group-item class="flex-column align-items-start">
                            <div class="d-flex w-100 justify-content-between">
                                <h3 class="app-title mb-1">Requisição Criada</h3>
                            </div>
                            <ul>
                                <li v-if="requisicao.titularReceita == 0 && requisicao.procurador != null">
                                    Requisição <b>{{retornoSalvar.id}}</b> {{nova ? 'criada' : 'alterada'}} com sucesso e aguardando validação pelo Procurador.
                                </li>
                                <li v-if="requisicao.titularReceita == 0 && requisicao.procurador == null">
                                    A {{requisicao.procurador}} Requisição <b>{{retornoSalvar.id}}</b> {{nova ? 'criada' : 'alterada'}} com sucesso.
                                </li>
                                <li v-if="requisicao.titularReceita >= 1">
                                    Requisição <b>{{retornoSalvar.id}}</b> criada com sucesso e encaminhada à CES.
                                </li>
                                <li>
                                    A Requisição criada abrangeu a(s) seguinte(s) CDA(s) ajuizada(s): <b>{{cdas()}}</b>
                                </li>
                            </ul>
                        </b-list-group-item>
                        <b-list-group-item class="flex-column align-items-start" v-if="retornoSalvar.arquivo != null">
                            <div class="d-flex w-100 justify-content-between">
                                <h3 class="app-title mb-1">Requisição Criada</h3>
                            </div>
                            <embed  id="guiaPdf"
                                    type="application/pdf"
                                    width="100%"
                                    height="400px"/>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: ['requisicao', 'retornoSalvar', 'nova'],
        data() {
            return {
                urlApi: null,
                urlPdf: null,
            }
        },
        methods: {
            nomeDevedorFormatado() {
                return this.requisicao.devedor.nome +
                    (this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                        this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                    this.requisicao.devedor.documento + ')';
            },
            cdas(){
                let cdas = "";
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    if((this.requisicao.pagamento && !this.requisicao.pagamento.refis) || this.requisicao.cdas[i].refisAtivo == 'S') {
                        cdas += (cdas != "" ? ", " : "") + this.requisicao.cdas[i].numeroDivida;
                    }
                }

                return cdas;
            },

            concluir() {
                this.$router.push({path: '/honorarios'});
            },
            numeroRequisicoes() {
                let numeros = "";
                for(var i = 0; i < this.listaRequisicao.length; i++) {
                    if((i + 1) == this.listaRequisicao.length) {
                        numeros += " e ";
                    } else if(i > 0) {
                        numeros += ", ";
                    }
                    numeros += this.listaRequisicao[i];
                }
                return numeros;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
        }
    }
</script>
<style>
</style>
